import ErrorBoundary from 'components/error-boundary/error-boundary';
import Page from 'components/page';
import LoadFailed from 'components/page-error/load-failed';
import useIntlMessages from 'hooks/use-intl-messages';
import AnonymousMessages from 'intl/anonymous-messages';
import isNil from 'lodash/isNil';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Redirect, Route, Switch} from 'react-router-dom';
import {useSelector} from 'redux-store';
import MeteorCookies from 'utils/meteor-cookies';
import S from './anonymous.less';
import ImpersonateUserSuccess from './views/impersonate-user-success';
import InvalidPassword from './views/invalid-password';
import Login from './views/login';
import LoginLaerdal from './views/login-laerdal';
import LoginSSOSuccess from './views/login-sso-success';
import Passthrough from './views/passthrough';
import RequestResetPassword from './views/request-reset-password';
import ResetPassword from './views/reset-password';

const LoginPath = '/login';
const LoginLaerdalPath = '/login/laerdal';
const PassthroughPath = '/passthrough';
const SsoPath = '/sso';
const ImpersonateUserSuccessPath = '/impersonate-user-success';
const ResetEmailPasswordPath = '/reset-password-email';
const RequestResetPasswordPath = '/request-reset-password';
const ExpiredPasswordPath = '/expired-password';
const ResetPasswordPath = '/reset-password';

const loginRoutes = [
    {
        path: LoginPath,
        title: AnonymousMessages.login,
        Component: Login,
    },
    {
        path: LoginLaerdalPath,
        title: AnonymousMessages.login,
        Component: LoginLaerdal,
    },
    {
        path: PassthroughPath,
        title: AnonymousMessages.login,
        Component: Passthrough,
    },
    {
        path: SsoPath,
        title: AnonymousMessages.login,
        Component: LoginSSOSuccess,
    },
];

const AnonymousRoutes = () => {
    const isLoaded = useIntlMessages('anonymous');
    const modals = useSelector((state) => state.modals.modals);

    if (!isLoaded) {
        return null;
    }

    const cookies = MeteorCookies.getInstance();

    const isLoggedIn = !isNil(cookies.get('token'));

    return (
        <div className={S.main}>
            <ErrorBoundary customErrorHandler={LoadFailed}>
                <Switch>
                    {loginRoutes.map((route, k) => {
                        const {path, title, Component} = route;

                        if (isLoggedIn) {
                            return <Redirect key={k} to='/' path={path} exact />;
                        }

                        return (
                            <Route
                                key={k}
                                path={path}
                                exact
                                render={(routeProps) => (
                                    <Page title={title}>
                                        <Component
                                            // @ts-expect-error TS2322: Type History<unknown> is not assignable to type History<LocationState>
                                            history={routeProps.history}
                                            // @ts-expect-error TS2322: Type Location<unknown> is not assignable to type Location<LocationState>
                                            location={routeProps.location}
                                            match={routeProps.match}
                                            staticContext={routeProps.staticContext}
                                        />
                                    </Page>
                                )}
                            />
                        );
                    })}
                    <Route path={ImpersonateUserSuccessPath} exact>
                        <Page title={AnonymousMessages.login}>
                            <ImpersonateUserSuccess />
                        </Page>
                    </Route>
                    <Route path={ResetEmailPasswordPath} exact>
                        <Page title={AnonymousMessages.titleForgotPassword}>
                            <ResetPassword />
                        </Page>
                    </Route>
                    <Route path={RequestResetPasswordPath} exact>
                        <Page title={AnonymousMessages.titleForgotPassword}>
                            <RequestResetPassword />
                        </Page>
                    </Route>
                    <Route
                        // TODO: MET-4435 expired-password requires a token to work. It isn't an anonymous route.
                        path={ExpiredPasswordPath}
                        exact>
                        <Page title={AnonymousMessages.expiredTitle}>
                            <InvalidPassword />
                        </Page>
                    </Route>
                    <Route path={ResetPasswordPath} exact>
                        <Page title={AnonymousMessages.expiredResetTitle}>
                            <InvalidPassword />
                        </Page>
                    </Route>
                </Switch>
                <div className={S.modalsLayer}>
                    {modals.toArray().map((modal, k) => {
                        return (
                            <div className={S.fill} key={k}>
                                {modal}
                            </div>
                        );
                    })}
                </div>
            </ErrorBoundary>
            <footer role='contentinfo' className={S.footer} title={`SimCapture v${__VERSION__}`}>
                <p>
                    <FormattedMessage {...AnonymousMessages.copyright} />
                </p>
            </footer>
        </div>
    );
};

export default AnonymousRoutes;

export const anonymousRoutePaths = [
    LoginPath,
    LoginLaerdalPath,
    PassthroughPath,
    SsoPath,
    ImpersonateUserSuccessPath,
    ResetEmailPasswordPath,
    RequestResetPasswordPath,
    ExpiredPasswordPath,
    ResetPasswordPath,
];
